__turbopack_context__.v({
  "copylink": "Share-module-scss-module__t6HNrq__copylink",
  "fade-in": "Share-module-scss-module__t6HNrq__fade-in",
  "icon": "Share-module-scss-module__t6HNrq__icon",
  "label": "Share-module-scss-module__t6HNrq__label",
  "linkCopied": "Share-module-scss-module__t6HNrq__linkCopied",
  "root": "Share-module-scss-module__t6HNrq__root",
  "tooltip": "Share-module-scss-module__t6HNrq__tooltip",
  "tooltipText": "Share-module-scss-module__t6HNrq__tooltipText",
});
